import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import InsertEdithDivCommand from "./command.js";

export default class LSDomElement extends Plugin {
    static get pluginName() {
        return "LSDomElement";
    }

    init() {
        const editor = this.editor;

        // ✅ Enregistrement de la commande
        editor.commands.add("insertEdithDiv", new InsertEdithDivCommand(editor));

        editor.ui.componentFactory.add("ls_dom_element", (locale) => {
            const button = new ButtonView(locale);

            button.set({
                label: "DIV",
                withText: true,
                tooltip: true,
            });

            this.listenTo(button, "execute", () => {
                const event = new CustomEvent("ckAddDomElement", {
                    detail: {
                        editor: editor,
                        type: "addDomElement",
                    },
                });
                document.dispatchEvent(event);
            });

            return button;
        });
    }
}
